import { IBusinessOperation } from './business-operations.model';
import { IBusinessOperationQualifier } from './business-operations-qualifiers.model';

export class IBusinessOperationQualifierList {
    businessOperationBusinessOperationQualifierList: IBusinessOperationQualifier[];
}

